import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = {
  key: 0,
  class: "card-title align-items-start flex-column",
  style: {"font-weight":"900","font-size":"large"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "container px-7" }, [
  /*#__PURE__*/_createElementVNode("hr", {
    style: {"width":"100%"},
    size: "3",
    color: "black"
  })
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "row mb-5" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  class: "col card-title flex-column",
  style: {"font-weight":"900","font-size":"large"}
}
const _hoisted_10 = {
  key: 0,
  class: "col d-flex justify-content-end"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_17 = { class: "col-lg-6 fv-row" }
const _hoisted_18 = { class: "row px-3" }
const _hoisted_19 = { class: "col-lg-12 fv-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Upload Desain Depan", -1)
const _hoisted_21 = ["onChange"]
const _hoisted_22 = { class: "col-lg-12 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Preview Kartu Depan", -1)
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "col-lg-6 fv-row" }
const _hoisted_26 = { class: "row px-3" }
const _hoisted_27 = { class: "col-lg-12 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Upload Desain Belakang", -1)
const _hoisted_29 = ["onChange"]
const _hoisted_30 = { class: "col-lg-12 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Preview Kartu Belakang", -1)
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "card-body py-3" }
const _hoisted_34 = { class: "row mb-5" }
const _hoisted_35 = {
  class: "card-title align-items-start flex-column mt-4",
  style: {"font-weight":"900","font-size":"large"}
}
const _hoisted_36 = { class: "col-lg-12 fv-row" }
const _hoisted_37 = { class: "row px-3" }
const _hoisted_38 = { class: "col-lg-12 fv-row" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Nama Desain", -1)
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = {
  key: 0,
  class: "card-footer border-0 d-flex justify-content-end py-0 px-9"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 1,
  class: "card-footer border-0 d-flex justify-content-end py-0 px-9"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "row mt-5 mb-5" }
const _hoisted_46 = ["id"]
const _hoisted_47 = { class: "modal-dialog" }
const _hoisted_48 = { class: "modal-content" }
const _hoisted_49 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, "Desain Kartu", -1)
const _hoisted_51 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_52 = { class: "svg-icon svg-icon-2x" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body row pt-1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "row",
    style: {"font-size":"16px","text-align":"center","margin-top":"15px"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-7" }, " Apakah anda akan menggunakan desain kartu ini? ")
  ])
], -1)
const _hoisted_54 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "row mt-5 mb-5" }
const _hoisted_58 = {
  class: "modal fade",
  tabindex: "-1",
  id: 'modal-confirm-design'
}
const _hoisted_59 = { class: "modal-dialog" }
const _hoisted_60 = { class: "modal-content" }
const _hoisted_61 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, "Desain Kartu", -1)
const _hoisted_63 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_64 = { class: "svg-icon svg-icon-2x" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body row pt-1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "row",
    style: {"font-size":"16px","text-align":"center","margin-top":"15px"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-7" }, " Apakah anda akan menggunakan desain kartu ini? ")
  ])
], -1)
const _hoisted_66 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "card-footer border-0 d-flex justify-content-center py-6 px-9" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus fs-4 me-2" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createTextVNode("Tambah Desain ")
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = { class: "card-footer d-flex justify-content-end py-6 px-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.role != 'CS_LEADER' && _ctx.role != 'CS_MEMBER')
          ? (_openBlock(), _createElementBlock("h3", _hoisted_3, " 1. Form Upload Desain "))
          : _createCommentVNode("", true)
      ]),
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputData, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (!item.isDelete)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h3", _hoisted_9, " Desain " + _toDisplayString(index + 1), 1),
                      (item.createTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("a", {
                              class: "symbol symbol-35px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Edit",
                              style: {"cursor":"pointer"},
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleEdit()))
                            }, _hoisted_12),
                            _createElementVNode("a", {
                              class: "me-2 symbol symbol-35px",
                              title: "View",
                              style: {"cursor":"pointer"},
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#kt_modal_2",
                              onClick: ($event: any) => (_ctx.handleDelete(index, item._id))
                            }, _hoisted_15, 8, _hoisted_13)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          (_openBlock(), _createElementBlock("input", {
                            name: "image",
                            type: "file",
                            id: "image",
                            class: "form-control form-control-lg",
                            onChange: ($event: any) => (_ctx.handleFileDesainDepan($event, index)),
                            key: _ctx.fileInputKey1
                          }, null, 40, _hoisted_21))
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("img", {
                            alt: "image",
                            class: "pl-3",
                            style: {"max-width":"350px"},
                            src: _ctx.imageShow[index]?.image1
                          }, null, 8, _hoisted_24)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          (_openBlock(), _createElementBlock("input", {
                            name: "image2",
                            type: "file",
                            id: "image2",
                            class: "form-control form-control-lg",
                            onChange: ($event: any) => (_ctx.handleFileDesainBelakang($event, index)),
                            key: _ctx.fileInputKey1
                          }, null, 40, _hoisted_29))
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createElementVNode("img", {
                            alt: "image2",
                            class: "pl-3",
                            style: {"max-width":"350px"},
                            src: _ctx.imageShow[index]?.image2
                          }, null, 8, _hoisted_32)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("h3", _hoisted_35, " Keterangan Desain " + _toDisplayString(index + 1), 1),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _withDirectives(_createElementVNode("input", {
                            name: "desainName",
                            type: "text",
                            id: "desainName",
                            class: "form-control form-control-lg",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.inputData[index].name) = $event)
                          }, null, 8, _hoisted_40), [
                            [_vModelText, _ctx.inputData[index].name]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                (_ctx.isEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("button", {
                        class: "btn btn-md btn-primary me-3",
                        id: "btnBayar",
                        type: "button",
                        onClick: ($event: any) => (_ctx.saveEdit(item._id, index))
                      }, " Simpan ", 8, _hoisted_42)
                    ]))
                  : _createCommentVNode("", true),
                (!item.createTime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("button", {
                        class: "btn btn-md btn-primary me-3",
                        id: "btnBayar",
                        type: "button",
                        onClick: ($event: any) => (_ctx.saveModal(index))
                      }, " Simpan ", 8, _hoisted_44)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", {
              class: "modal fade",
              tabindex: "-1",
              id: 'modal-save-design' + index
            }, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("span", _hoisted_52, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                      ])
                    ])
                  ]),
                  _hoisted_53,
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      "data-bs-dismiss": "modal",
                      onClick: ($event: any) => (_ctx.saveDesign(index))
                    }, " Ok ", 8, _hoisted_56)
                  ])
                ])
              ])
            ], 8, _hoisted_46)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("span", _hoisted_64, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                      ])
                    ])
                  ]),
                  _hoisted_65,
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      "data-bs-dismiss": "modal",
                      onClick: ($event: any) => (_ctx.verifyDesign(index))
                    }, " Ok ", 8, _hoisted_68)
                  ])
                ])
              ])
            ])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addDesign())),
          class: "btn btn-md btn-primary me-3",
          id: "btnBayar",
          type: "button"
        }, _hoisted_72)
      ]),
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("button", {
          class: "btn btn-danger me-3",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/superadmin/cart-product')))
        }, " Kembali "),
        _createElementVNode("button", {
          class: "btn btn-warning me-3",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/superadmin/daftar-product')))
        }, " Update "),
        _createElementVNode("button", {
          class: "btn btn-primary me-3",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.verifyModal()))
        }, " Verifikasi ")
      ])
    ], 2)
  ], 64))
}